<template>
  <div class="article-categories-page">
    <div class="filter-bar">
      <div class="search-box">
        <input 
          type="text" 
          v-model="searchKey" 
          placeholder="搜索分类名称..."
          class="search-input"
        />
        <button @click="search" class="search-btn">搜索</button>
      </div>
      <button @click="showCategoryModal = true" class="add-btn">+ 添加分类</button>
    </div>

    <div class="table-container">
      <table class="categories-table">
        <thead>
          <tr>
            <th>分类ID</th>
            <th>分类名称</th>
            <th>层级</th>
            <th>排序</th>
            <th>文章数量</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in treeCategories" :key="category.id">
            <td>{{ category.id }}</td>
            <td>
              <span :style="{ paddingLeft: (category.level - 1) * 24 + 'px' }" class="tree-node">
                <span v-if="category.level > 1" class="tree-line">└─</span>
                {{ category.category_name }}
              </span>
            </td>
            <td>{{ category.level === 1 ? '一级' : category.level === 2 ? '二级' : '三级' }}</td>
            <td>{{ category.sort_order }}</td>
            <td>{{ category.article_count || 0 }}</td>
            <td><span :class="'status ' + (category.status === 1 ? 'enabled' : 'disabled')">{{ category.status === 1 ? '启用' : '禁用' }}</span></td>
            <td>{{ formatDate(category.created_at) }}</td>
            <td>
              <button @click="addArticle(category)" class="action-btn add-article">添加文章</button>
              <button @click="editCategory(category)" class="action-btn edit">编辑</button>
              <button @click="toggleStatus(category)" class="action-btn" :class="category.status === 1 ? 'disable' : 'enable'">
                {{ category.status === 1 ? '禁用' : '启用' }}
              </button>
              <button @click="deleteCategory(category)" class="action-btn delete">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1" @click="currentPage--" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
      <button :disabled="currentPage === totalPages" @click="currentPage++" class="page-btn">下一页</button>
    </div>

    <div v-if="showCategoryModal" class="modal-overlay" @click.self="closeCategoryModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingCategory ? '编辑分类' : '添加分类' }}</h3>
          <button @click="closeCategoryModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>分类名称</label>
            <input v-model="categoryForm.category_name" type="text" class="form-control" placeholder="请输入分类名称" />
          </div>
          <div class="form-group">
            <label>父级分类</label>
            <select v-model.number="categoryForm.parent_id" class="form-control">
              <option :value="0">无（一级分类）</option>
              <option v-for="cat in parentOptions" :key="cat.id" :value="cat.id">
                {{ cat.level === 2 ? '└─ ' : '' }}{{ cat.category_name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>当前层级</label>
            <select v-model.number="categoryForm.level" class="form-control" disabled>
              <option :value="1">一级分类</option>
              <option :value="2">二级分类</option>
              <option :value="3">三级分类</option>
            </select>
          </div>
          <div class="form-group">
            <label>排序</label>
            <input v-model.number="categoryForm.sort_order" type="number" class="form-control" placeholder="数字越小越靠前" />
          </div>
          <div class="form-group">
            <label>状态</label>
            <select v-model.number="categoryForm.status" class="form-control">
              <option :value="1">启用</option>
              <option :value="0">禁用</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeCategoryModal" class="btn-cancel">取消</button>
          <button @click="saveCategory" class="btn-save">保存</button>
        </div>
      </div>
    </div>

    <!-- 添加文章弹窗 -->
    <div v-if="showArticleModal" class="modal-overlay" @click.self="closeArticleModal">
      <div class="modal-content modal-large">
        <div class="modal-header">
          <h3>添加文章</h3>
          <button @click="closeArticleModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>文章标题</label>
            <input v-model="articleForm.title" type="text" class="form-control" placeholder="请输入文章标题" />
          </div>
          <div class="form-group">
            <label>所属分类</label>
            <select v-model.number="articleForm.category_id" class="form-control">
              <option :value="0">请选择分类</option>
              <option v-for="cat in articleCategoryOptions" :key="cat.id" :value="cat.id">
                {{ cat.level === 2 ? '└─ ' : '' }}{{ cat.category_name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>作者名称 <span style="color:#e74c3c">*</span></label>
            <input v-model="articleForm.author" type="text" class="form-control" placeholder="请输入作者名称" />
          </div>
          <div class="form-row">
            <div class="form-group form-group-half">
              <label>排序</label>
              <input v-model.number="articleForm.sort" type="number" class="form-control" placeholder="数字越小越靠前" />
            </div>
            <div class="form-group form-group-half">
              <label>状态</label>
              <select v-model.number="articleForm.status" class="form-control">
                <option :value="0">草稿</option>
                <option :value="1">已发布</option>
                <option :value="2">下架</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group form-group-half">
              <label>是否置顶</label>
              <select v-model.number="articleForm.is_top" class="form-control">
                <option :value="0">否</option>
                <option :value="1">是</option>
              </select>
            </div>
            <div class="form-group form-group-half">
              <label>是否热门</label>
              <select v-model.number="articleForm.is_hot" class="form-control">
                <option :value="0">否</option>
                <option :value="1">是</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group form-group-half">
              <label>定时发布时间（为空立即发布）</label>
              <input v-model="articleForm.publish_time" type="datetime-local" class="form-control" />
            </div>
            <div class="form-group form-group-half">
              <label>过期时间（选填）</label>
              <input v-model="articleForm.expire_time" type="datetime-local" class="form-control" />
            </div>
          </div>
          <div class="form-group">
            <label>文章内容</label>
            <div class="editor-toolbar">
              <button
                @click="showHtmlMode = !showHtmlMode"
                class="toolbar-btn"
                :class="{ active: showHtmlMode }"
              >
                {{ showHtmlMode ? '可视化' : 'HTML源码' }}
              </button>
            </div>
            <textarea
              v-if="showHtmlMode"
              v-model="articleForm.content"
              class="form-control content-textarea html-textarea"
              rows="10"
              placeholder="请输入HTML代码..."
            ></textarea>
            <div
              v-else
              class="form-control content-editable"
              contenteditable="true"
              @input="onContentInput"
              placeholder="请输入可视化的文章内容..."
              v-html="articleForm.content"
            ></div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeArticleModal" class="btn-cancel">取消</button>
          <button @click="saveArticle" class="btn-save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getArticleCategoryList,
  createArticleCategory,
  updateArticleCategory,
  deleteArticleCategory,
  createArticle
} from '@/api/articles'

export default {
  name: 'ArticleCategories',
  data() {
    return {
      searchKey: '',
      currentPage: 1,
      totalPages: 10,
      showCategoryModal: false,
      editingCategory: null,
      categoryForm: {
        category_name: '',
        parent_id: 0,
        level: 1,
        sort_order: 100,
        status: 1
      },
      categories: [],
      // 文章弹窗相关
      showArticleModal: false,
      showHtmlMode: false,
      articleForm: {
        title: '',
        category_id: 0,
        content: '',
        author: '广西南宁贞吉商务有限公司',
        sort: 100,
        is_top: 0,
        is_hot: 0,
        status: 0,
        publish_time: '',
        expire_time: ''
      }
    }
  },
  watch: {
    'categoryForm.parent_id'(newVal) {
      if (newVal === 0) {
        this.categoryForm.level = 1
      } else {
        const parent = this.categories.find(cat => cat && cat.id === newVal)
        this.categoryForm.level = parent ? parent.level + 1 : 2
      }
    }
  },
  computed: {
    parentOptions() {
      const filtered = this.categories.filter(cat => cat && cat.id !== undefined && cat.level < 3 && (!this.editingCategory || cat.id !== this.editingCategory.id))
      const result = []
      const level1 = filtered.filter(cat => cat && cat.level === 1).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      level1.forEach(l1 => {
        if (!l1) return
        result.push(l1)
        const level2 = filtered.filter(cat => cat && cat.parent_id === l1.id).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        level2.forEach(l2 => {
          if (!l2) return
          result.push(l2)
        })
      })
      return result
    },
    treeCategories() {
      const allCategories = this.categories.filter(cat => cat && cat.id !== undefined)
      const result = []
      const rootCategories = allCategories.filter(cat => cat && cat.parent_id === 0)
      
      const buildTree = (parentId, level) => {
        const children = allCategories.filter(cat => cat && cat.parent_id === parentId)
        children.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        
        children.forEach(child => {
          if (!child) return
          result.push({ ...child, level })
          buildTree(child.id, level + 1)
        })
      }
      
      rootCategories.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      rootCategories.forEach(root => {
        if (!root) return
        result.push({ ...root, level: 1 })
        buildTree(root.id, 2)
      })
      
      return result
    },
    articleCategoryOptions() {
      const activeCategories = this.categories.filter(cat => cat && cat.status === 1)
      const parentCategories = activeCategories.filter(cat => cat && cat.level === 1).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      const result = []
      parentCategories.forEach(parent => {
        if (!parent) return
        result.push(parent)
        const children = activeCategories.filter(cat => cat && cat.parent_id === parent.id).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        children.forEach(child => {
          if (!child) return
          result.push(child)
        })
      })
      return result
    }
  },
  mounted() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      try {
        const params = { page: this.currentPage }
        if (this.searchKey.trim()) {
          params.keyword = this.searchKey.trim()
        }
        const response = await getArticleCategoryList(params)
        if (response && response.data) {
          const pageData = response.data
          const items = pageData.data || pageData
          this.categories = Array.isArray(items) ? items.filter(cat => cat && cat.id !== undefined) : []
          this.totalPages = pageData.last_page || 10
        }
      } catch (error) {
      }
    },
    search() {
      this.currentPage = 1
      this.loadCategories()
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },
    // 添加文章：打开弹窗并预选分类
    addArticle(category) {
      this.resetArticleForm()
      this.articleForm.category_id = category ? category.id : 0
      this.showArticleModal = true
    },
    onContentInput(event) {
      this.articleForm.content = event.target.innerHTML
    },
    editCategory(category) {
      this.editingCategory = category
      this.categoryForm.category_name = category.category_name
      this.categoryForm.parent_id = category.parent_id
      this.categoryForm.level = category.level
      this.categoryForm.sort_order = category.sort_order || 100
      this.categoryForm.status = category.status
      this.showCategoryModal = true
    },
    async toggleStatus(category) {
      const action = category.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}分类 ${category.category_name} 吗？`)) {
        try {
          const newStatus = category.status === 1 ? 0 : 1
          await updateArticleCategory(category.id, { status: newStatus })
          category.status = newStatus
        } catch (error) {
          alert('更新状态失败')
        }
      }
    },
    async deleteCategory(category) {
      if (confirm(`确定要删除分类 ${category.category_name} 吗？`)) {
        try {
          await deleteArticleCategory(category.id)
          this.categories = this.categories.filter(cat => cat.id !== category.id)
          alert('删除成功')
        } catch (error) {
          alert('删除失败，请稍后重试')
        }
      }
    },
    closeCategoryModal() {
      this.showCategoryModal = false
      this.editingCategory = null
      this.categoryForm = {
        category_name: '',
        parent_id: 0,
        level: 1,
        sort_order: 100,
        status: 1
      }
    },
    async saveCategory() {
      if (!this.categoryForm.category_name.trim()) {
        alert('请输入分类名称')
        return
      }

      try {
        if (this.editingCategory) {
          await updateArticleCategory(this.editingCategory.id, this.categoryForm)
          Object.assign(this.editingCategory, this.categoryForm)
          alert('更新成功')
        } else {
          const response = await createArticleCategory(this.categoryForm)
          const newCategory = response.data.data || response.data
          if (newCategory && newCategory.id !== undefined) {
            this.categories.unshift(newCategory)
          }
          alert('添加成功')
        }
        this.closeCategoryModal()
        this.loadCategories()
      } catch (error) {
        const message = error.response?.data?.message || error.message || '保存失败，请稍后重试'
        alert(message)
      }
    },
    // 文章弹窗逻辑
    resetArticleForm() {
      this.showHtmlMode = false
      this.articleForm = {
        title: '',
        category_id: 0,
        content: '',
        author: '广西南宁贞吉商务有限公司',
        sort: 100,
        is_top: 0,
        is_hot: 0,
        status: 0,
        publish_time: '',
        expire_time: ''
      }
    },
    closeArticleModal() {
      this.showArticleModal = false
      this.resetArticleForm()
    },
    formatDateTime(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toISOString().slice(0, 16)
    },
    async saveArticle() {
      if (!this.articleForm.title.trim()) {
        alert('请输入文章标题')
        return
      }
      if (this.articleForm.category_id === 0) {
        alert('请选择所属分类')
        return
      }

      const submitData = {
        ...this.articleForm,
        publish_time: this.articleForm.publish_time || null,
        expire_time: this.articleForm.expire_time || null
      }

      try {
        const response = await createArticle(submitData)
        const newArticle = response.data.data || response.data
        if (newArticle && newArticle.id !== undefined) {
          alert('添加成功')
        } else {
          alert('添加成功')
        }
        this.closeArticleModal()
        // 重新拉取分类列表，以后台返回的 article_count 为权威值
        await this.loadCategories()
      } catch (error) {
        let message = '保存失败，请稍后重试'
        const resp = error.response && error.response.data
        if (resp && resp.errors) {
          const first = Object.values(resp.errors)[0]
          message = Array.isArray(first) ? first[0] : (resp.message || message)
        } else if (resp && resp.message) {
          message = resp.message
        } else if (error.message) {
          message = error.message
        }
        alert(message)
      }
    }
  }
}
</script>

<style scoped>
.article-categories-page {
  padding: 20px;
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.search-box {
  display: flex;
  gap: 10px;
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  width: 250px;
}

.search-btn {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.add-btn {
  padding: 10px 20px;
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.categories-table {
  width: 100%;
  border-collapse: collapse;
}

.categories-table th, .categories-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.categories-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.status {
  padding: 4px 0;
  border-radius: 20px;
  font-size: 12px;
}

.status.enabled { background: #e8f5e9; color: #2ecc71; }
.status.disabled { background: #ffebee; color: #e74c3c; }

.tree-node {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.tree-line {
  color: #999;
  font-size: 12px;
}

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
}

.action-btn.add-article {
  background: #9b59b6;
  color: #fff;
}

.action-btn.edit {
  background: #3498db;
  color: #fff;
}

.action-btn.disable {
  background: #e74c3c;
  color: #fff;
}

.action-btn.enable {
  background: #2ecc71;
  color: #fff;
}

.action-btn.delete {
  background: #95a5a6;
  color: #fff;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-large {
  width: 700px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-btn {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.content-textarea {
  font-family: inherit;
  resize: vertical;
}

.form-row {
  display: flex;
  gap: 15px;
}

.form-group-half {
  flex: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.btn-save {
  padding: 8px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.editor-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.toolbar-btn {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f8f9fa;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.3s;
}

.toolbar-btn:hover {
  background: #e9ecef;
}

.toolbar-btn.active {
  background: #3498db;
  color: #fff;
  border-color: #3498db;
}

.content-editable {
  min-height: 200px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}

.content-editable:empty:before {
  content: attr(placeholder);
  color: #999;
  pointer-events: none;
}

.content-editable:focus {
  border-color: #3498db;
}

.html-textarea {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
}
</style>